module.exports = __webpack_public_path__ + "img/Flag_of_Tajikistan.0a1708be.svg";